// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bookmark';

export const Component = () => (
  <path d='M18.26 0H7.486c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 6 1.485v22.558c0 .335.191.479.527.479.143 0 .239-.048.287-.144l6.082-5.747 6.034 5.747a.434.434 0 0 0 .336.144c.335 0 .479-.144.479-.479V1.485c0-.431-.144-.766-.432-1.054A1.408 1.408 0 0 0 18.26 0h.002Zm.528 1.484v21.408l-5.89-5.603-5.891 5.603V1.484c0-.335.144-.526.479-.526h10.776c.335 0 .526.191.526.526Z' />
);

export const viewBox = '0 0 25 25';
